import { render, staticRenderFns } from "./DeviceDataBatches.vue?vue&type=template&id=627d0636"
import script from "./DeviceDataBatches.vue?vue&type=script&lang=js"
export * from "./DeviceDataBatches.vue?vue&type=script&lang=js"
import style0 from "./DeviceDataBatches.vue?vue&type=style&index=0&id=627d0636&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports